import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

export const AOSWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    AOS.refreshHard(); // ✅ refresh ONLY when route changes
  }, [location.pathname]);

  return null;
};
